module.exports = __webpack_public_path__ + "static/media/15_digginglight.d4f77a04.jpg";